<div class="flex my-4 items-center clickable-card-parent">
  <div
    class="mx-auto clickable-card flex flex-col items-center justify-center cursor-pointer text-center px-3 {{reduced ? 'md:h-20' : 'md:h-36'}}"
    (mouseenter)="mouseEnter(item)"
    (mouseleave)="mouseLeave(item)"
    *ngFor="let item of responses; let i = index"
    (click)="onItemSelected(item)"
    (keydown)="onKeyDown($event, item, i)"
    [ngClass]="setClassActive(item)"
    [tabindex]="0"
    [attr.role]="'button'"
    [attr.aria-label]="item.key"
    [attr.aria-pressed]="isSelected(item)">
    <app-svg-viewer class="icon md:block hidden" *ngIf="item.svg" [svg]="item.svg"></app-svg-viewer>
    <p [innerHTML]="item.key"></p>
  </div>
</div>
